import type { ScoreBand } from '@/types/insights';

/**
 * Single source of truth for temperature -> color across the choropleth,
 * legend, and any badges. Uses a diverging blue (cold) -> gray (neutral)
 * -> red (hot) ramp, consistent with the "hot/cold" naming throughout.
 */
export function colorForBand(band: ScoreBand): string {
  switch (band.label) {
    case 'hot':
      return '#b91c1c';
    case 'warming':
      return '#f97316';
    case 'neutral':
      return '#94a3b8';
    case 'cooling':
      return '#3b82f6';
    case 'cold':
      return '#1d4ed8';
    default:
      return '#e2e8f0';
  }
}

export function fillOpacityForBand(band: ScoreBand): number {
  if (band.label === 'insufficient-data') return 0.25;
  const magnitude = Math.min(1, Math.abs(band.value) / 100);
  return 0.35 + magnitude * 0.5;
}
